import React from "react";
import PropTypes from "prop-types";

const COPY_STROKE_D =
  "M17 3a2.04 2.04 0 0 1-.53 3.265L15 7h0l-1.001 1.001.61 1.826a2 2 0 0 1-.484 2.048L8 18h0l-.882-.882A2.56 2.56 0 0 1 6.5 14.5h0a2.56 2.56 0 0 1-2.618-.618L2 12h0l6.133-6.133a2 2 0 0 1 2.033-.487l1.851.603h0L13 5l.735-1.47A2.04 2.04 0 0 1 17 3M7 7l6 6m-6.5 1.5L8 13";

const PASTE_STROKE_D =
  "M17 3a2.04 2.04 0 0 1-.53 3.265L15 7h0l-1.001 1.001.61 1.826a2 2 0 0 1-.484 2.048L8 18h0l-1-1 1.5-1.5a1.414 1.414 0 1 0-2-2L5 15h0l-3-3 6.133-6.133a2 2 0 0 1 2.033-.487l1.851.603h0L13 5l.735-1.47A2.04 2.04 0 0 1 17 3M7 7l6 6";

const PASTE_FILL_D = "m2 12 3 3 2.5-2.5L9 14l-2.5 2.5L8 18l5-5-6-6z";

const StyleBrushIcon = ({
  variant,
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => {
  const fillColor = color || "#57595d";
  const isPaste = variant === "paste";

  return (
    <svg
      className={className}
      style={style}
      data-no-pointer={noPointer}
      width={width || size || 20}
      height={height || size || 20}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="title"
    >
      <title>{title}</title>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h20v20H0z" />
        <path
          stroke={fillColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d={isPaste ? PASTE_STROKE_D : COPY_STROKE_D}
        />
        {isPaste && <path fill={fillColor} d={PASTE_FILL_D} />}
      </g>
    </svg>
  );
};

StyleBrushIcon.propTypes = {
  variant: PropTypes.oneOf(["copy", "paste"]).isRequired,
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default StyleBrushIcon;
